import {texture} from "p3";
import common from "../../common";
import GameScene from "../../scenes/GameScene";
import { locale, resizeLabelToFitText } from "../../utils";

export default class IdleMessage extends PIXI.Container {
    /**
     * @param {string} message
     */
    constructor(message, onComplete) {
        super();

        this._message = message;
        this._onComplete = onComplete;
        this._holder = null;
        this._banner = null;
        this._margin = 40;

        this.init();
    }

    init() {

        this._holder = new PIXI.Container();
        this.addChild(this._holder);

        this._banner = new PIXI.NineSlicePlane(texture('dialogue_name_panel_9slice'), 14, 14, 14, 30);
        this._banner.width = 350;
        this._holder.addChild(this._banner);

        this._label = new PIXI.BitmapText(this._message, {
            fontName: "Alghera Pro",
            fontSize: 22,
            align: "center",
            tint: 0x000000,
            maxWidth: this._banner.width - this._banner.leftWidth - this._banner.rightWidth
        });
        this._label.anchor.set(0.5, 0);
        this._label.x = this._banner.width / 2;
        this._label.y = this._banner.topHeight;
        this._holder.addChild(this._label);

        this._banner.height = this._label.height + (this._banner.topHeight * 2);

        this.animateIn();
        this.animateOut();
    }

    animateIn() {
        this._holder.x = -this._label.width - this._margin;
        GameScene.active.addTween(gsap.to(this._holder, 1, {x:this._margin, ease:Expo.easeOut}));
    }

    animateOut() {
        GameScene.active.addTween(gsap.to(this, 1, {delay:5, x:-this._label.width - this._margin, ease:Expo.easeIn, onComplete:() => {
            this.parent.removeChild(this);
            if(this._onComplete)
                this._onComplete();
        }}));
    }
}


